import {getId, getType} from 'apis/model/base'
import _ from 'lodash'
import React, {useContext} from 'react'
import {MultiCategoryPicker} from 'views/AppLocals/custom/TagsPicker'
import {SubCategoryTypes} from 'views/AppLocals/factory/createEntityManager'
import {createControlledFormField} from 'views/AppLocals/factory/createFormField'
import SubCategoriesSelect from 'views/Workspace/SubCategories/SubCategoriesSelect'
import OrganizationContainerContext from '../OrganizationContainerContext'
import {PartialEditGroupWrapper} from "../../../../components/form/PartialEditForm";
import {NullAsDefault, shallowDiff} from "../../../Shared";
import Translate from "../../../../modules/local/Translate";
import {useOrganizationApi} from "../functions/useOrganizationApi";
import {GoDotFill} from "react-icons/go";
import categoryIcons from "../../../../conts/categoryIcons";

const formFields = [
    {
        name: 'tags',
        defaultValue: undefined,
    },
    {
        name: 'categories',
        defaultValue: undefined,
    },
    {
        name: 'categories of organization',
        defaultValue: undefined,
    },
]

const formSchema = [
    {
        title: 'categories',
        children: [
            {
                name: 'categories',
                component: createControlledFormField({
                    Component: MultiCategoryPicker,
                }),
            },
        ],
    },
    {
        title: 'categories of organization',
        children: [
            {
                name: 'subcategories',
                component: ({name, form, value, onChange}) => {
                    const defaultValue = form?.values?.defaultSubCategories
                    return (
                        <OrganizationContainerContext.Consumer>
                            {({organization}) => (
                                <SubCategoriesSelect
                                    {...{
                                        name,
                                        value,
                                        onChange,
                                        defaultValue,
                                    }}
                                    className="custom-multi-select"
                                    type={SubCategoryTypes.ORGANIZATION.value}
                                    owner_id={getId(organization)}
                                    owner_type={getType(organization)}
                                />
                            )}
                        </OrganizationContainerContext.Consumer>
                    )
                },
            },
        ],
    },
]

const groupFields = {
    categoriesGroup: {
        title: 'categories',
        render: (item) => {
            const {categories = []} = item ?? {}

            return (
                <Translate>
                    {(t) => (
                        <div className="flex flex-col gap-2">
                            <div className="flex items-center gap-2 tracking-wider">
                                <GoDotFill size={10} className="text-color-400"/>
                                <span className="text-color-400 whitespace-no-wrap italic">
                                    {`${t('categories')}: `}
                                </span>
                            </div>
                            <div className="flex items-center gap-4">
                                {categories?.map((e, i) => {
                                    const Icon = _.get(categoryIcons, getId(e), categoryIcons['default']) ?? NullAsDefault
                                    return (
                                        <div
                                            key={i}
                                            className="flex flex-center gap-2">
                                            <Icon size={14}/>
                                            <span className="font-semibold text-sm italic leading-tight">
                                                {e.name}
                                            </span>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )}
                </Translate>
            )
        },
        formSchemas: [
            {
                title: 'categories',
                children: [
                    {
                        name: 'categories',
                        component: createControlledFormField({
                            Component: MultiCategoryPicker,
                        }),
                    },
                ],
            },
            {
                title: 'categories of organization',
                children: [
                    {
                        name: 'subcategories',
                        component: ({name, form, value, onChange}) => {
                            const defaultValue = form?.values?.defaultSubCategories
                            return (
                                <OrganizationContainerContext.Consumer>
                                    {({organization}) => (
                                        <SubCategoriesSelect
                                            {...{
                                                name,
                                                value,
                                                onChange,
                                                defaultValue,
                                            }}
                                            className="custom-multi-select"
                                            type={SubCategoryTypes.ORGANIZATION.value}
                                            owner_id={getId(organization)}
                                            owner_type={getType(organization)}
                                        />
                                    )}
                                </OrganizationContainerContext.Consumer>
                            )
                        },
                    },
                ],
            },
        ],
        onValidate: (values, t) => {

            let errors = {}

            return errors
        },
    },
}

const OrganizationSettingCategories = () => {
    const {organization} = useContext(OrganizationContainerContext)

    const organization_id = getId(organization)

    const initialValues = {
        ...organization,
        categories: _.get(organization, 'categories', []),
    }

    const {onUpdate} = useOrganizationApi({})

    if (_.isEmpty(organization)) return null

    return (
        <div className="flex flex-col gap-3">
            <PartialEditGroupWrapper
                groupFields={[
                    groupFields.categoriesGroup,
                ]}
                initialValues={initialValues}
                item={initialValues}
                onSubmit={({...values}) => {
                    const {...changes} = shallowDiff(values, initialValues)
                    onUpdate(
                        _.omitBy({...changes,}, _.isUndefined),
                        {id: organization_id}
                    )
                }}
            />
        </div>
    )

    // return createEditableForm(
    //     formFields,
    //     formSchema
    // )({
    //     item: organization,
    //     validationSchema,
    //     query: bindQueryParam({
    //         id: organization_id,
    //     }),
    //     onPreSubmit: ({
    //                       tags,
    //                       categories,
    //                       subcategories,
    //                       defaultSubCategories,
    //                       ...values
    //                   }) =>
    //         _.omitBy(
    //             {
    //                 ...values,
    //                 tags: tags ? Array.from(tags || []).join(',') : undefined,
    //                 categories: categories
    //                     ? Array.from(categories || []).join(',')
    //                     : undefined,
    //                 subcategories: subcategories
    //                     ? Array.from(subcategories || []).join(',')
    //                     : undefined,
    //             },
    //             _.isUndefined
    //         ),
    //     initialized: ({tags, categories, subcategories, ...values}) => ({
    //         ...values,
    //         tags: Array.from(tags || []).map(({tags}) => tags),
    //         categories: mapEntityOptions(categories),
    //         subcategories: _.isArray(subcategories)
    //             ? Array.from(subcategories).map(getId)
    //             : undefined,
    //         defaultSubCategories: subcategories,
    //     }),
    //     apiInfo: organization_Edit_Api,
    // })
}

export default OrganizationSettingCategories
